import script from "./AddStudentView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddStudentView.vue?vue&type=script&lang=ts&setup=true"

import "./AddStudentView.vue?vue&type=style&index=0&id=1a23a8f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a23a8f7"]])

export default __exports__